// extracted by mini-css-extract-plugin
module.exports = {"faqCard":"Faq_faqCard__1WNQ9","faqHeader":"Faq_faqHeader__u5ZQg","faqBody":"Faq_faqBody__2uzdq"};